import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  restaurantCreatedAt: null,
};

const restaurantSlice = createSlice({
  name: "restaurant",
  initialState,
  reducers: {
    setCreationDate: (state, action) => {
      state.restaurantCreatedAt = action.payload;
    },
    clearRestaurant: (state) => {
      state = initialState;
    },
  },
});

export const { setCreationDate, clearRestaurant } = restaurantSlice.actions;
export default restaurantSlice.reducer;
